import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrowserBridgeService {
  private readonly document = inject(DOCUMENT);
  private readonly window = this.document.defaultView;

  openExternal(url: string, target = '_blank'): void {
    this.window?.open(url, target, 'noopener,noreferrer');
  }

  downloadBlob(blob: Blob, filename: string): void {
    const objectUrl = this.window?.URL.createObjectURL(blob);
    if (!objectUrl) return;

    const anchor = this.document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename;
    this.document.body.appendChild(anchor);
    anchor.click();
    this.document.body.removeChild(anchor);

    this.window?.URL.revokeObjectURL(objectUrl);
  }
}
